<template>
    <div class="tower page">
        <wrapper column background-color="#fff">
            <div class="data-section">
                <div class="float image-container">
                    <img
                        :src="require(`@/assets/Stage/Tower/top.png`)"
                        alt=""
                        width="100%"
                    />
                    <div class="banner">
                        <div class="text">闖關進度塔</div>
                        <div v-if="user" class="group">
                            {{
                                (user.group && user.group.name) ||
                                "尚未加入任何群組"
                            }}
                        </div>
                    </div>
                    <TowerSelect />
                </div>
                <div class="avatar">
                    <div class="level">
                        <img
                            :src="require(`@/assets/Stage/Medal/${medal}.png`)"
                            alt=""
                        />
                        <div class="data">LV {{ level }}</div>
                    </div>
                    <img
                        :src="
                            // eslint-disable-next-line max-len
                            require(`@/assets/Stage/Tower/Avatar/${$route.params.type}/level${$route.params.level}/${unlockLevel}.png`)
                        "
                        alt=""
                        width="100%"
                    />
                </div>
                <div v-if="user" class="user">
                    <div class="user-inner">
                        {{ user.name || defaultName }}
                    </div>
                </div>
                <div class="accumulation">
                    <div class="label">
                        <img src="@/assets/Stage/score.png" alt="" />
                        <div class="text">累積分數</div>
                    </div>
                    <div class="score">{{ score }}</div>
                </div>
            </div>
            <TowerView
                :key="`${$route.params.type}level${$route.params.level}`"
                @toggle="onToggle"
            />
            <!-- </div> -->
            <BackBtn />
        </wrapper>
        <transition name="fade" mode="out-in">
            <Profile v-if="formPopupState" @close="formPopupState = false" />
        </transition>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import PageGeneral from '@/mixins/PageGeneral';
import BackBtn from '@/components/Button/BackButton.vue';
import TowerSelect from '@/components/Stage/Tower/TowerSelect.vue';
import TowerView from '@/components/Stage/Tower/TowerView.vue';
import Profile from '@/components/Home/Profile.vue';

import Status from '@/mixins/Status';

export default {
    mixins: [PageGeneral, Status],
    components: {
        BackBtn,
        TowerSelect,
        TowerView,
        Profile,
    },
    data() {
        return {
            isTowerCollapse: true,
            formPopupState: false,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.user,
            defaultName: (state) => state.defaultName,
            towerUnlocked: (state) => state.towerUnlocked,
            accumulatedScore: (state) => state.accumulatedScore,
        }),
        unlockLevel() {
            if (!this.towerUnlocked?.game1) return 0;
            return this.towerUnlocked[this.$route.params.type][
                `level${this.$route.params.level}`
            ];
        },
    },
    async created() {
        await this.fetchTower();
    },
    methods: {
        ...mapActions({
            fetchTower: 'fetchTower',
        }),
        onToggle() {
            this.isTowerCollapse = !this.isTowerCollapse;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.data-section {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    &.collapse {
        flex: 0;
        overflow: hidden;
    }
}
.tower {
    .wrapper {
        overflow: hidden;
    }
    .image-container.float {
        position: relative;
        .banner {
            position: absolute;
            top: 20px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            .text {
                font-size: 2em;
                font-weight: bold;
                color: #fff;
            }
            .group {
                width: 162px;
                height: 25px;
                font-size: 12px;
                border-radius: 9.4px;
                background-color: #cbebff;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
    .avatar {
        position: relative;
        margin: 35px 0 10px;
        width: 170px;
        height: 170px;
        .level {
            position: absolute;
            width: 80%;
            top: 0;
            left: 50%;
            transform: translate(-50%, -66%);
            padding: 3px 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 20.5px;
            border: solid 3px #b1b1b1;
            background-image: linear-gradient(to bottom, #ffef77, #ffdb42);
            img {
                margin-right: 10px;
                width: 25px;
                height: 25px;
            }
            .data {
                flex: 1;
                text-align: center;
                transform: translateY(-0.1em);
                font-weight: bold;
            }
        }
    }
    .user {
        padding: 0 20px;
        font-size: 20px;
        color: #4683bc;
        width: 100%;
        height: 35px;
        background-color: #cbebff;
        display: flex;
        justify-content: center;
        align-items: center;
        .user-inner {
            max-width: 90%;
            margin: auto;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .change {
            cursor: pointer;
            white-space: nowrap;
            font-size: 18px;
            color: #888;
        }
        .space {
            width: 36px;
        }
    }
    .accumulation {
        width: 100%;
        padding: 5px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        // box-shadow: 0 2px 11px 0 rgba(42, 113, 136, 0.59);
        border: solid 1px #79c0ff;
        font-weight: bold;

        .label {
            display: flex;
            align-items: center;
            margin-right: 30px;
            img {
                margin-right: 5px;
                width: 35px;
                height: 35px;
            }
        }
        .score {
            color: #56a2e6;
        }
    }
}
.tower-view-section {
    z-index: 1;
    transition: 0.5s;
    position: absolute;
    width: 100%;
    height: 100%;
    transform: translateY(95%);
    .expend-btn {
        cursor: pointer;
        transition: 0.5s;
        position: relative;
        z-index: 1;
        color: #979797;
        height: 5%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            width: 20px;
            margin-right: 10px;
        }
    }
    &.collapse {
        transform: translateY(-5%);
        .expend-btn {
            transform: translateY(100%);
        }
    }
}
@media screen and (max-width: 320px) {
    .tower {
        .avatar {
            width: 120px;
            height: 120px;
            .level img {
                width: 20px;
                height: 20px;
            }
        }
        .data {
            font-size: 12px;
        }
    }
}
</style>
